(()=>{
  if(window.__WN_NAMI_STICKY_FAILSAFE_V2__) return;
  window.__WN_NAMI_STICKY_FAILSAFE_V2__=1;

  const FAILSAFE_BUILD='v14-20260928-locale-reset1';
  const legacyPathKey=`wn:nami:morph-failed:${location.pathname}`;
  const pathKey=`wn:nami:morph-failed:${FAILSAFE_BUILD}:${location.pathname}`;
  try{sessionStorage.removeItem(legacyPathKey)}catch{}
  const readFailed=()=>{try{return sessionStorage.getItem(pathKey)==='1'}catch{return false}};
  const rememberFailed=()=>{try{sessionStorage.setItem(pathKey,'1')}catch{}};
  const failedAtLoad=readFailed();

  const killStyle=document.createElement('style');
  killStyle.id='wn-nami-sticky-failsafe-styles';
  killStyle.textContent=`
    html.wn-nami-morph-failed .wn-nami-source-hidden,
    body.wn-nami-morph-failed .wn-nami-source-hidden{opacity:1!important;visibility:visible!important;pointer-events:auto!important}
    html.wn-nami-morph-failed .wn-nami-elastic-clone,
    html.wn-nami-morph-failed .wn-nami-pop,
    html.wn-nami-morph-failed .wn-nami-footer-cue,
    html.wn-nami-morph-failed .wn-nami-story__purchase-rail.wn-nami-elastic-owned,
    body.wn-nami-morph-failed .wn-nami-elastic-clone,
    body.wn-nami-morph-failed .wn-nami-pop,
    body.wn-nami-morph-failed .wn-nami-footer-cue,
    body.wn-nami-morph-failed .wn-nami-story__purchase-rail.wn-nami-elastic-owned{display:none!important;visibility:hidden!important;pointer-events:none!important}
  `;
  document.head.appendChild(killStyle);

  const markFailed=()=>{
    document.documentElement.classList.add('wn-nami-morph-failed');
    document.body?.classList.add('wn-nami-morph-failed');
  };

  if(failedAtLoad){
    markFailed();
    window.__WN_NAMI_STICKY_ELASTIC_V14__=1;
  }

  const validRect=(r)=>r&&Number.isFinite(r.left)&&Number.isFinite(r.top)&&Number.isFinite(r.width)&&Number.isFinite(r.height)&&r.width>12&&r.height>12;
  const railIsVisible=(rail)=>!!rail&&(rail.classList.contains('wn-nami-elastic-show')||rail.classList.contains('is-visible'))&&getComputedStyle(rail).visibility!=='hidden'&&getComputedStyle(rail).display!=='none';

  function setup(root){
    if(!root||root.dataset.wnNamiFailsafeReady==='1') return;
    const controller=root.wnNamiController;
    const source=controller?.productHtmlForm?.querySelector?.('[data-add-to-cart]');
    const rail=controller?.rail;
    if(!controller||!source||!rail) return;
    root.dataset.wnNamiFailsafeReady='1';

    let disabled=failedAtLoad;
    let missingVisualSince=0;
    let overlapSince=0;
    let lastMotionAt=performance.now();
    let lastSignature='';

    const restoreSource=()=>{
      source.classList.remove('wn-nami-source-hidden');
      source.style.removeProperty('opacity');
      source.style.removeProperty('visibility');
      source.style.removeProperty('pointer-events');
      source.removeAttribute('aria-hidden');
    };

    const disableMorph=(reason='unknown')=>{
      if(disabled) return;
      disabled=true;
      rememberFailed();
      markFailed();
      restoreSource();
      document.querySelectorAll('.wn-nami-elastic-clone,.wn-nami-pop').forEach(node=>{
        try{node.getAnimations?.().forEach(a=>a.cancel())}catch{}
        node.remove();
      });
      try{rail.getAnimations?.().forEach(a=>a.cancel())}catch{}
      rail.classList.remove('wn-nami-elastic-show','is-visible','wn-nami-elastic-measure');
      rail.setAttribute('aria-hidden','true');
      rail.setAttribute('inert','');
      root.dataset.wnNamiMorphFailed=reason;
    };

    if(disabled){restoreSource();return}

    const check=()=>{
      if(disabled) return;
      try{
        if(!source.isConnected||!controller.productHtmlForm?.isConnected){disableMorph('source-disconnected');return}
        const clones=[...document.querySelectorAll('.wn-nami-elastic-clone')];
        if(clones.length>1){disableMorph('duplicate-clones');return}
        const clone=clones[0]||null;
        const hidden=source.classList.contains('wn-nami-source-hidden');
        const railVisible=railIsVisible(rail);
        const now=performance.now();

        if(!hidden){
          missingVisualSince=0;overlapSince=0;lastMotionAt=now;lastSignature='';return;
        }

        if(clone){
          const rect=clone.getBoundingClientRect();
          if(!validRect(rect)){disableMorph('invalid-clone-geometry');return}
          const animSig=clone.getAnimations?.().map(a=>`${a.playState}:${Math.round(Number(a.currentTime)||0)}`).join(',')||'';
          const sig=[clone.style.left,clone.style.top,clone.style.width,clone.style.height,clone.style.transform,clone.style.opacity,animSig].join('|');
          if(sig!==lastSignature){lastSignature=sig;lastMotionAt=now}
          if(!railVisible&&now-lastMotionAt>2100){disableMorph('stalled-clone');return}
        }

        if(!clone&&!railVisible){
          if(!missingVisualSince) missingVisualSince=now;
          if(now-missingVisualSince>1200){disableMorph('no-usable-atc-visual');return}
        }else missingVisualSince=0;

        if(clone&&railVisible){
          if(!overlapSince) overlapSince=now;
          if(now-overlapSince>750){disableMorph('stuck-handoff');return}
        }else overlapSince=0;

        if(railVisible){
          const rr=rail.getBoundingClientRect();
          const add=controller.railAdd||rail.querySelector('[data-wn-nami-rail-add]');
          if(!validRect(rr)||!add){disableMorph('invalid-sticky-atc');return}
        }
      }catch{disableMorph('watchdog-exception')}
    };

    const timer=setInterval(check,250);
    controller.abortController?.signal?.addEventListener('abort',()=>clearInterval(timer),{once:true});
  }

  const scan=(scope=document)=>{
    if(scope.matches?.('[data-wn-nami-story]')) setup(scope);
    scope.querySelectorAll?.('[data-wn-nami-story]').forEach(setup);
  };

  window.addEventListener('error',(event)=>{
    const file=String(event.filename||'');
    if(file.includes('wn-nami-sticky-morph')){
      rememberFailed();markFailed();
      document.querySelectorAll('[data-wn-nami-story]').forEach(root=>{
        const source=root.wnNamiController?.productHtmlForm?.querySelector?.('[data-add-to-cart]');
        source?.classList.remove('wn-nami-source-hidden');
      });
    }
  },true);

  window.addEventListener('wheel',(event)=>{
    if(document.documentElement.classList.contains('wn-nami-morph-failed')) event.stopImmediatePropagation();
  },{capture:true,passive:true});
  window.addEventListener('touchmove',(event)=>{
    if(document.documentElement.classList.contains('wn-nami-morph-failed')) event.stopImmediatePropagation();
  },{capture:true,passive:true});

  document.addEventListener('wn:nami:ready',(event)=>requestAnimationFrame(()=>setup(event.target.closest?.('[data-wn-nami-story]')||event.target)));
  document.addEventListener('shopify:section:load',(event)=>requestAnimationFrame(()=>scan(event.target)));
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>{markFailedIfNeeded();scan();setTimeout(()=>scan(),250)},{once:true});
  else {markFailedIfNeeded();scan();setTimeout(()=>scan(),250)}

  function markFailedIfNeeded(){if(readFailed()){markFailed();window.__WN_NAMI_STICKY_ELASTIC_V14__=1}}
})();